import { INVESTMENT_PROFILE_TYPE_JOINT } from "@components/Domain";

type Investment = {
  profileType?: string;
};

const isJointInvestment = ({ profileType }: Investment): boolean => {
  const isJoint = profileType === INVESTMENT_PROFILE_TYPE_JOINT;

  return isJoint;
};

export default isJointInvestment;
